import styled from 'styled-components';

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: flex-start;
`;

export const EventSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px 24px;
  height: auto;
  width: 100%;
  color: ${({ theme }) => theme.colors.black9};
`;

export const EventInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
`;

export const EventContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  width: 100%;
  flex: 1;
  min-width: 0;
  overflow-y: hidden;
  height: calc(100vh - 130px);

  @media (max-width: ${({ theme }) => theme.mediaQueries.md}) {
    height: 100%;
    overflow-y: auto;
    flex-direction: column;
  }
`;

export const CenterWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const Wrapper = styled.div`
  padding-top: 52px;
  width: 100%;
  max-width: 1160px;
  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    padding-top: 24px;
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    padding-top: 0px;
  }
`;

export const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    display: grid;
    grid-template-columns: 60fr 40fr;
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    column-gap: 24px;
    row-gap: 32px;
    & > :nth-child(1) {
      grid-area: 1 / 1 / 2 / 2;
    }
    & > :nth-child(2) {
      grid-area: 1 / 2 / 2 / 3;
    }
    & > :nth-child(3) {
      grid-area: 2 / 1 / 3 / 2;
    }
  }
`;

export const WidgetWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 5px;
  padding: 20px;
`;
